import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { gql, useQuery } from '@apollo/client'

import { Col, Radio, Row } from 'antd'
import CartItemsContainer from './CartItems'
import CartCompanies from './Companies'
import CartShippingAddresses from './ShippingAddresses'
import CartDeliveryOptions from './DeliveryOptions'
import CartSummary from './Summary'

const GET_CUSTOMER_CART_QUERY = gql`
  query GetCustomerCart($customerId: String!) {
    customerCart(customerNo: $customerId) {
      id
      itemIds
      shippingAddress {
        id
        provinceId
        districtId
      }
    }
  }
`

const dataParser = customerCart => {
  if (!customerCart) return {}

  const { itemIds, shippingAddress } = customerCart || {}

  return {
    itemsCount: itemIds ? itemIds.length : 0,
    defaultShippingAddress: shippingAddress ? shippingAddress.id : null
  }
}

const CartContainer = ({ customerId }) => {
  const [purchaseAs, setPurchaseAs] = useState('person')
  const [customerCompanyId, setCustomerCompanyId] = useState(null)

  const [shippingAddress, setShippingAddress] = useState(null)
  const [shippingType, setShippingType] = useState()
  
  const { data, error } = useQuery(GET_CUSTOMER_CART_QUERY, {
    variables: { customerId }
  })

  if (error) { console.error(error) }

  const { itemsCount, defaultShippingAddress } = data ? dataParser(data.customerCart) : {}

  const onChangeCustomerCompany = value => {
    if (purchaseAs === 'person') return null

    setCustomerCompanyId(value)
  }

  const onChangePurchaseAs = event => {
    const value = event.target.value

    if (value === 'person') {
      setCustomerCompanyId(null)
    }

    setShippingAddress(null)
    setPurchaseAs(value)
  }

  const onChangeShippingAddress = args => {
    setShippingAddress({
      id: args.id,
      provinceId: args.provinceId,
      districtId: args.districtId
    })
  }

  const onChangeShippingType = option => {
    setShippingType(option.type)
  }

  if (itemsCount < 1) {
    return (
      <Row gutter={[16, 24]}>
        <CartItemsContainer customerId={customerId} />
      </Row>
    )
  }

  return (
    <Row gutter={[16, 24]}>
      <CartItemsContainer customerId={customerId} />

      <Col xs={24} md={4}>สั่งซื้อในนาม</Col>
      <Col xs={24} md={20}>
        <Radio.Group onChange={onChangePurchaseAs} value={purchaseAs}>
          <Radio.Button value="person">บุคคล</Radio.Button>
          <Radio.Button value="company">บริษัท</Radio.Button>
        </Radio.Group>
      </Col>

      {purchaseAs === 'company' && (
        <Fragment>
          <Col xs={24} md={4}>บริษัท</Col>
          <Col xs={24} md={20}>
            <CartCompanies
              customerId={customerId}
              onChange={onChangeCustomerCompany}
              selected={customerCompanyId} />
          </Col>
        </Fragment>
      )}

      <Col xs={24} md={4}>ที่อยู่จัดส่ง</Col>
      <Col xs={24} md={20}>
        <CartShippingAddresses
          customerId={customerId}
          defaultFormCart={defaultShippingAddress}
          customerCompanyId={customerCompanyId}
          onChange={onChangeShippingAddress}
          selected={shippingAddress} />
      </Col>

      {shippingAddress && (
        <Fragment>
          <Col xs={24} md={4}>รูปแบบจัดส่ง</Col>
          <Col xs={24} md={20}>
            <CartDeliveryOptions
              customerId={customerId}
              provinceId={shippingAddress ? shippingAddress.provinceId : null}
              districtId={shippingAddress ? shippingAddress.districtId : null}
              onChange={onChangeShippingType}
              value={shippingType} />
          </Col>
        </Fragment>
      )}

      <Col xs={24} md={{ span: 8, offset: 16 }}>
        <CartSummary
          customerId={customerId}
          provinceId={shippingAddress ? shippingAddress.provinceId : null}
          districtId={shippingAddress ? shippingAddress.districtId : null}
          shippingType={shippingType} />
      </Col>
    </Row>
  )
}

CartContainer.propTypes = {
  customerId: PropTypes.string.isRequired
}

export default CartContainer
